(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alex-shoe-care"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('alex-shoe-care')) return;
    class AlexShoeCare extends HTMLElement {
      static pending = false;

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('submit', this.addCare, { signal: this.controller.signal });
        document.addEventListener('cart:update', this.onCartUpdate, { signal: this.controller.signal });
        const button = this.querySelector('button[type="submit"]');
        if (button) button.disabled = AlexShoeCare.pending;
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onCartUpdate = (event) => {
        const items = event.detail?.resource?.items;
        if (!Array.isArray(items)) return;
        this.hidden = items.some((item) => String(item.product_id) === this.dataset.productId);
      };

      addCare = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (AlexShoeCare.pending) return;
        AlexShoeCare.pending = true;
        const root = window.Shopify?.routes?.root || '/';
        const status = this.querySelector('[data-care-status]');
        const label = this.querySelector('[data-care-button-label]');
        const originalLabel = label.textContent;
        let added = false;
        document.querySelectorAll('alex-shoe-care button[type="submit"]').forEach((button) => { button.disabled = true; });
        status.textContent = '';
        label.textContent = this.dataset.adding;
        this.setAttribute('aria-busy', 'true');

        try {
          const beforeResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!beforeResponse.ok) throw new Error(this.dataset.error);
          const before = await beforeResponse.json();
          const present = before.items.some((item) => String(item.product_id) === this.dataset.productId);
          let cart = before;
          let sections;

          if (!present) {
            const sectionIds = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), (element) => element.dataset.sectionId))].slice(0, 5);
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: this.dataset.variantId, quantity: 1 }],
                sections: sectionIds,
                sections_url: window.location.pathname + window.location.search
              })
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            added = true;
            sections = result.sections;
            const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!cartResponse.ok) throw new Error(this.dataset.error);
            cart = await cartResponse.json();
          }

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'alex-shoe-care',
              data: { source: 'alex-shoe-care', productId: this.dataset.productId, itemCount: cart.item_count, sections }
            }
          }));
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          status.textContent = error.message || this.dataset.error;
        } finally {
          AlexShoeCare.pending = false;
          this.removeAttribute('aria-busy');
          label.textContent = originalLabel;
          document.querySelectorAll('alex-shoe-care button[type="submit"]').forEach((button) => { button.disabled = false; });
        }
      };
    }
    customElements.define('alex-shoe-care', AlexShoeCare);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alex-welcome-offer"] && !Shopify.designMode) return;
  try {
    (function(){
  const dialog=document.getElementById('alex-welcome-offer');
  if(!dialog||typeof dialog.showModal!=='function')return;
  const key='alex-welcome-offer-v1';
  try{if(sessionStorage.getItem(key))return;}catch{}
  const open=()=>{
    if(document.querySelector('dialog[open]'))return;
    dialog.showModal();
    try{sessionStorage.setItem(key,'1');}catch{}
  };
  const schedule=()=>window.setTimeout(open,1200);
  if(document.readyState==='complete')schedule();
  else window.addEventListener('load',schedule,{once:true});
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const rect=dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
